import Vue from "vue";
import Router from "vue-router";
import Store from "../store";

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) return {selector: to.hash}
    if (savedPosition) return savedPosition
    return {x: 0, y: 0}
  },
  routes: [
    {
      path: "",
      component: () => import(
        /* webpackChunkName: "layout-[request]" */
        `@/layouts/main/Index`
        ),
      children: [
        {
          name: "Dashboard",
          path: "",
          component: () => import("../views/Dashboard"),
          meta: {
            admin: true
          }
        },
        {
          name: "Downloads",
          path: "/downloads",
          component: () => import("../views/downloads/DownloadList"),
          meta: {
            admin: true
          }
        },
        {
          name: "Metering Data Overview",
          path: "/metering-data",
          component: () => import("../views/endpoints/EndpointList"),
          meta: {
            admin: true
          }
        },
        {
          name: "Metering Data",
          path: "/metering-data/:id",
          props: route => ({
            id: route.params.id
          }),
          component: () => import("../views/endpoints/EndpointSingle")
        },
        {
          name: "Single Meter",
          path: "/metering-data/:id/meter/:meter",
          props: route => ({
            id: route.params.id,
            meter: route.params.meter,
          }),
          component: () => import("../views/endpoints/EndpointMeter")
        },
        {
          name: "Credit Billing Overview",
          path: "/credit-billing",
          component: () => import("../views/credit-billing/CreditBillingList"),
          meta: {
            admin: true
          }
        },
        {
          name: "Credit Billing Development",
          path: "/credit-billing/:id",
          props: route => ({
            id: route.params.id
          }),
          component: () => import("../views/credit-billing/CreditBillingSingle")
        },
        {
          name: "Credit Billing Development Bills",
          path: "/credit-billing/:id/bills",
          props: route => ({
            id: route.params.id
          }),
          component: () => import("../views/credit-billing/CreditBillingBills")
        },
        {
          name: "Credit Billing Development Accounts",
          path: "/credit-billing/:id/accounts",
          props: route => ({
            id: route.params.id
          }),
          component: () => import("../views/credit-billing/CreditBillingAccounts")
        },
        {
          name: "Credit Billing Reports",
          path: "/credit-billing/:id/reports",
          props: route => ({
            id: route.params.id
          }),
          component: () => import("../views/credit-billing/CreditBillingReports")
        },
        {
          name: "My Account",
          path: "/user",
          component: () => import("../views/user/UserAccount")
        }
      ]
    },
    {
      path: "",
      component: () => import(
        /* webpackChunkName: "layout-[request]" */
        `@/layouts/auth/Index`
        ),
      children: [
        {
          name: "Login",
          path: "login",
          component: () => import("../views/auth/Login"),
          meta: {
            admin: true
          }
        },
        {
          name: "Forgot Password",
          path: "password-forgot",
          component: () => import("../views/auth/ForgotPassword"),
          meta: {
            admin: true
          }
        },
        {
          name: "Reset Password",
          path: "password-reset/:resetKey",
          props: route => ({
            "resetKey": route.params.resetKey,
          }),
          component: () => import("../views/auth/ResetPassword"),
          meta: {
            admin: true
          }
        },
        {
          name: "Verify Account",
          path: "verify/:verifyKey",
          props: route => ({
            "verifyKey": route.params.verifyKey,
          }),
          component: () => import("../views/auth/VerifyAccount"),
          meta: {
            admin: true
          }
        }
      ]
    },
    {
      path: "*",
      name: "Error",
      component: () => import(
        /* webpackChunkName: "layout-[request]" */
        `@/layouts/error/Index`
      )
    }
  ]
});

router.beforeEach(async (to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page

  const publicPageGroups = [
    "login",
    "password-forgot",
    "password-reset",
    "verify"
  ];
  const authRequired = !publicPageGroups.includes(to.path.split("/")[1])
  const loggedIn = Store.getters['auth/isLoggedIn'];

  if (authRequired && !loggedIn) {
    if (to.path !== '/') {
      return next("/login?redirect=" + to.path);
    }
    return next("/login");
  }

  if (publicPageGroups.includes(to.path.split("/")[1]) && loggedIn) {
    return next("/");
  }

  if (loggedIn) {
    const verified = await Store.dispatch("auth/verify");
    if (!verified) {
      return next("/login");
    }
    await Store.dispatch("downloads/connectSocket");
  }

  next();
});

export default router;
